import LandingImersao  from "./LandingImersao";
function App() {
  return (
    <div className="App">
      <LandingImersao  />
    </div>
  );
}

export default App;
